import * as fromDatatype from '../datatype-library/index';

export interface app_perm_assign_role_guid_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  perm_dfn_guid: fromDatatype.GuidDataFieldInterface;
  assignee_type: fromDatatype.VarcharDatatypeInterface;
  assignee_hdr_table: fromDatatype.VarcharDatatypeInterface;
  assignee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  assignee_line_table: fromDatatype.VarcharDatatypeInterface;
  assignee_line_guid: fromDatatype.GuidDataFieldInterface;
  target_type: fromDatatype.VarcharDatatypeInterface;
  target_policy: fromDatatype.JsonDatatypeInterface;
  target_filter: fromDatatype.JsonDatatypeInterface;
  target_hdr_table: fromDatatype.VarcharDatatypeInterface;
  target_hdr_guid: fromDatatype.GuidDataFieldInterface;
  target_line_table: fromDatatype.VarcharDatatypeInterface;
  target_line_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_perm_assign_role_guid_RowClass
  implements app_perm_assign_role_guid_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  perm_dfn_guid: fromDatatype.GuidDataFieldInterface;
  assignee_type: fromDatatype.VarcharDatatypeInterface;
  assignee_hdr_table: fromDatatype.VarcharDatatypeInterface;
  assignee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  assignee_line_table: fromDatatype.VarcharDatatypeInterface;
  assignee_line_guid: fromDatatype.GuidDataFieldInterface;
  target_type: fromDatatype.VarcharDatatypeInterface;
  target_policy: fromDatatype.JsonDatatypeInterface;
  target_filter: fromDatatype.JsonDatatypeInterface;
  target_hdr_table: fromDatatype.VarcharDatatypeInterface;
  target_hdr_guid: fromDatatype.GuidDataFieldInterface;
  target_line_table: fromDatatype.VarcharDatatypeInterface;
  target_line_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
